import * as Swiper from 'swiper/dist/js/swiper.js';

export default class initHpSlider {
    constructor() {
        this.container = document.querySelector('.cp-hp-slider');

        this.container2 = document.querySelector('.cp-hp-slider-actu-event ');
        if (this.container === null && this.container2  === null) return;

        this.sliders = document.querySelectorAll('.js-hp-slider');

        Array.from(this.sliders).forEach((slider) => {
            this.initSlider(slider)
        });

    }

    initSlider(slider) {

        if (slider.querySelectorAll('.swiper-slide').length <= 3 && window.innerWidth > 768) {
          slider.querySelector('.nav-container').classList.add('hidden');
        }

        let slidesPerViewResp;
        let space;

        if(window.innerWidth < 768){
            slidesPerViewResp = 1.1;
            space = 16;
        }else{
            slidesPerViewResp = 3;
            space = 24;
        }

        new Swiper(slider, {
            slidesPerView: slidesPerViewResp,
            slideClass: 'item',
            spaceBetween: space,
            navigation: {
                nextEl: '.js-slider-hp-button-next',
                prevEl: '.js-slider-hp-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: '-current',
                clickable: true,
            },
            
        });
    }
}
